import React, {Component} from 'react';
import ReactPlayer from 'react-player';

class Stream extends Component {
    render() {
        return  (
            <div className='player-wrapper'>
                <div className='react-player'>
                    <ReactPlayer url={this.props.src}
                                 // loop
                                 controls
                                 playsinline
                                 playing />
                </div>
            </div>

        )
    }
}

Stream.propTypes = {
    src: React.PropTypes.string.isRequired
};

export default Stream;


// WEBPACK FOOTER //
// ./js/sport-betting/components/stream/Stream.jsx